<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="w-100 text-center px-4 py-3 flex items-center justify-between banner"
    >
      <span class="font-medium">
        Motorsport related items currently have 2–3 weeks wait.
        If urgent please call us.
      </span>
    </div>
  </transition>
</template>

<script setup>
import { ref } from 'vue'

const visible = ref(true)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.banner {
  background-color: #e0901f;
  color: #fff;
  position: absolute;
  bottom: 0;
  z-index: 999999;
}

</style>
